/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {colors} from "nxtconstants";

import {
  wrapper,
  title,
  button,
  infoline,
  loader,
  error
} from "../styledElements";

const propTypes = {
  handleOtp: PropTypes.func,
  handleResend: PropTypes.func,
  isVerifying: PropTypes.bool,
  userData: PropTypes.object
};

const OtpVerification = ({
  handleOtp,
  isVerifying,
  userData,
  handleResend
}) => {
  return (
    <UserCredentialsWrapper>
      <Title>Enter OTP</Title>
      <InfoLine>
        We have sent an OTP to your Phone Number
      </InfoLine>
      <PhoneNo>
        +91-{userData.phone_number.replace("(+91)", "")}
      </PhoneNo>
      <OtpWrapper>
        {
          isVerifying && (
            <Loader />
          )
        }
        <OtpInput
          autoFocus
          maxLength="6"
          type="number"
          onKeyUp={(e) => handleOtp(e)}
        />
        <InputBars>
          <Bar />
          <Bar />
          <Bar />
          <Bar />
          <Bar />
          <Bar />
        </InputBars>
      </OtpWrapper>
      <ResendOtp>
        Haven’t received an OTP yet? <ResendLink onClick={() => handleResend()}>Resend</ResendLink>
      </ResendOtp>
      <SubmitCredentials>
        Verify
      </SubmitCredentials>
    </UserCredentialsWrapper>
  );
};

const UserCredentialsWrapper = styled(wrapper)``;

const Title = styled(title)``;

const InfoLine = styled(infoline)``;

const ResendOtp = styled(infoline)`
  margin-top: 1.4rem;
`;

const ResendLink = styled.button`
  color: ${colors.primary};
  background-color: transparent;
  border: 0;
  font-size: 1.6rem;
  cursor: pointer;
`;

const PhoneNo = styled.h3`
  color: ${colors.black};
  font-size: 2rem;
  text-align: center;
  line-height: 1;
  margin-bottom: 3rem;
`;

const OtpWrapper = styled.div`
  position: relative;
  margin-bottom: 1.5rem;
  width: 282px;
  margin: 0 auto;

  &::after {
    content: "";
    position: absolute;
    height: 100%;
    width: 5rem;
    top: 0;
    right: -5rem;
    background-color: ${colors.white};
  }

  @media (max-width: 768px) {
    width: 200px;
  }
`;

const Loader = styled(loader)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  background-color: rgba(255,255,255,0.9);
`;

const OtpInput = styled.input`
  display: block;
  width: 130%;
  letter-spacing: 36px;
  padding: 1.2rem 0;
  padding-left: 10px;
  font-size: 24px;
  border: 0;
  outline: 0;
  color: ${colors.black};
  font-weight: 400;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @media (max-width: 768px) {
    font-size: 20px;
    letter-spacing: 24px;
    padding-left: 5px;
  }
`;

const InputBars = styled.div`
  display: block;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const Bar = styled.div`
  height: 1px;
  flex: 1;
  background-color: ${colors.textGray};
`;

const SubmitCredentials = styled(button)`
  width: 100%;
  margin: 4.4rem 0;

  @media (max-width: 768px) {
    margin: 2.5rem 0 0;
  }
`;

OtpVerification.propTypes = propTypes;

export default OtpVerification;
